import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  messages: [],
  isGenerating: false,
  isDownloading: false,
  isLoading: false,
};

const collySlice = createSlice({
  name: 'colly',
  initialState,
  reducers: {
    setMessages: (state, action) => {
      state.messages = action.payload;
    },
    setIsGenerating: (state, action) => {
      state.isGenerating = action.payload;
    },
    setIsDownloading: (state, action) => {
      state.isDownloading = action.payload;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setShowExport: (state, action) => {
      state.showExport = action.payload;
    },
    addMessage: (state, action) => {
      state.messages.push(action.payload);
    },
    updateLastMessage: (state, action) => {
      if (state.messages.length > 0) {
        state.messages[state.messages.length - 1] = action.payload;
      }
    },
    resetChat: () => initialState,
  },
});

// Export actions
export const {
  setMessages,
  setIsGenerating,
  setIsDownloading,
  setIsLoading,
  addMessage,
  updateLastMessage,
  resetChat,
} = collySlice.actions;

// Export selectors
export const selectMessages = (state) => state.colly.messages;
export const selectIsGenerating = (state) => state.colly.isGenerating;
export const selectIsLoading = (state) => state.colly.isLoading;
export const selectIsDownloading = (state) => state.colly.isDownloading;

export default collySlice.reducer;
